export default {
    // START:: NOTIFICATIONS GETTER
    wishlistData(state) {
        return state.wishlist;
    },
    // END:: NOTIFICATIONS GETTER
};